<div class="options-selector" *ngIf="canUse">
    <a href="" class="option-tick" (click)="approveSuggestion(); false;"><i class="fa fa-check"></i></a>
    <a href="" class="option-cross" (click)="removeSuggestion(); false;"><i class="fa fa-trash"></i></a>
</div>